import { useEffect, useRef, useState } from 'react';

const BOOK_IMAGE = 'https://static.readdy.ai/image/dfc6db26b98ba2c0b04cea29bf715fac/f9d260390a36324976fee1c367228296.png';

export default function SolucionSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-white py-20 md:py-28 px-6 md:px-12" ref={ref}>
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
        {/* Image */}
        <div
          className={`w-full lg:w-[420px] flex-shrink-0 transition-all duration-800 ${
            visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
          }`}
        >
          <div className="relative">
            <div className="absolute -inset-4 bg-emerald-100 rounded-3xl -z-10" />
            <div className="w-full h-[480px] lg:h-[540px] rounded-2xl overflow-hidden">
              <img
                src={BOOK_IMAGE}
                alt="Programa Digital ElaBooks"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 -right-5 bg-amber-400 rounded-2xl px-5 py-4 text-emerald-950">
              <div className="text-3xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>30</div>
              <div className="text-xs font-semibold">días de programa</div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div
          className={`flex-1 transition-all duration-800 delay-200 ${
            visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
          }`}
        >
          <span className="inline-block text-emerald-700 text-xs font-bold tracking-widest uppercase mb-4">
            La Solución
          </span>
          <h2
            className="text-3xl md:text-5xl font-bold text-stone-900 leading-tight mb-5"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            No es solo un ebook.{' '}
            <span className="text-emerald-700">Es un programa completo.</span>
          </h2>
          <p className="text-stone-600 text-lg leading-relaxed mb-6">
            Es un <strong>Programa Digital de 30 Días</strong> diseñado para ayudarte a reorganizar las finanzas de tu familia, eliminar deudas y crear hábitos económicos saludables para el futuro.
          </p>
          <p className="text-stone-600 text-base leading-relaxed mb-8">
            No necesitas conocimientos financieros avanzados. Solo necesitas un sistema claro que te ayude a tomar decisiones inteligentes con tu dinero.
          </p>

          <div className="flex flex-col gap-4">
            {[
              'Un plan estructurado paso a paso para 30 días',
              'Aplicable a cualquier nivel de ingresos',
              'Diseñado para toda la familia, incluidos los hijos',
              'Resultados visibles desde la primera semana',
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-emerald-100 flex-shrink-0">
                  <i className="ri-check-line text-emerald-700 text-sm font-bold" />
                </div>
                <span className="text-stone-700 text-sm font-medium">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
